import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { trackSignUp } from "@/lib/analytics";
import { submitPendingQuiz } from "@/lib/pendingQuiz";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post("/auth/google", { session_id: sessionId });
        setUser(data);
        if (data.is_new_user) trackSignUp("google");
        window.history.replaceState(null, "", window.location.pathname);
        // finish an anonymous quiz taken before signing up with Google
        const pending = await submitPendingQuiz();
        if (pending) {
          await checkAuth();
          navigate((data.role === "admin" || data.is_subscribed) ? "/dashboard" : "/subscribe", { replace: true });
          return;
        }
        navigate(data.has_path ? "/dashboard" : "/quiz", { replace: true });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
